import { CmsVendor } from "@modules/graphql/types"
import {
  ContentfulAddedDocument,
  DatoCmsAddedDocument,
  SanityAddedDocument,
} from "@modules/cms/shared/queries.generated"
import { useEffect, useState } from "react"
import { useApolloClient } from "react-apollo"
import { VerificationStatus } from "../../shared/utils/constants"

const cmsSubscriptionDocuments = {
  [CmsVendor.Contentful]: ContentfulAddedDocument,
  [CmsVendor.Datocms]: DatoCmsAddedDocument,
  [CmsVendor.Sanity]: SanityAddedDocument,
}

export const useCmsAuthStatus = (cmsVendor, siteId, initialValue) => {
  const [modalState, setModalState] = useState(initialValue)
  const client = useApolloClient()

  useEffect(() => {
    if (cmsVendor && cmsSubscriptionDocuments[cmsVendor] && siteId) {
      const subscription = client
        .subscribe({
          query: cmsSubscriptionDocuments[cmsVendor],
          variables: { siteId },
        })
        .subscribe({
          next: ({ data }) => {
            const keys = Object.keys(data)
            if (keys.find(key => key.includes(`IntegrationAdded`))) {
              setModalState(VerificationStatus.Authorized)
            }
          },
        })

      return () => subscription.unsubscribe()
    }
  }, [client, cmsVendor, siteId])

  const requestAuthorization = () =>
    setModalState(VerificationStatus.Authorization)

  const handleAuthorized = () => setModalState(VerificationStatus.Authorized)

  const handleAuthorizing = () => {
    setModalState(VerificationStatus.Authorizing)

    if (process.env.GATSBY_MOCK_MODE) {
      setModalState(VerificationStatus.Authorized)

      return true // allows to interrupt in children
    }
  }

  return [modalState, handleAuthorized, handleAuthorizing, requestAuthorization]
}
